import { createAction } from "@reduxjs/toolkit";
import {
  blockCreatorActionTypes,
  followCreatorActionTypes,
  getCreatorProfileActionTypes,
  hideReportActionTypes,
  setConversationActionType,
  setCreatorSubscriptionActionTypes,
  setCreatorSubscriptionPortionActionTypes,
  unblockCreatorActionTypes,
  unfollowCreatorActionTypes,
} from "./actionTypes";

export const getCreatorProfile = createAction(
  getCreatorProfileActionTypes.request,
  (payload) => ({ payload }),
);

export const getCreatorProfileSuccess = createAction(
  getCreatorProfileActionTypes.success,
  (payload) => ({ payload }),
);

export const getCreatorProfileFailure = createAction(
  getCreatorProfileActionTypes.failure,
  (error) => ({ payload: error }),
);

export const getCreatorProfileReset = createAction(
  getCreatorProfileActionTypes.reset,
  (payload) => ({ payload }),
);

export const blockCreator = createAction(
  blockCreatorActionTypes.request,
  (payload) => ({ payload }),
);

export const blockCreatorSuccess = createAction(
  blockCreatorActionTypes.success,
  (payload) => ({ payload }),
);

export const blockCreatorFailure = createAction(
  blockCreatorActionTypes.failure,
  (error) => ({ payload: error }),
);

export const unblockCreator = createAction(
  unblockCreatorActionTypes.request,
  (payload) => ({ payload }),
);

export const unblockCreatorSuccess = createAction(
  unblockCreatorActionTypes.success,
  (payload) => ({ payload }),
);

export const unblockCreatorFailure = createAction(
  unblockCreatorActionTypes.failure,
  (error) => ({ payload: error }),
);

export const followCreator = createAction(
  followCreatorActionTypes.request,
  (payload) => ({ payload }),
);

export const followCreatorSuccess = createAction(
  followCreatorActionTypes.success,
  (payload) => ({ payload }),
);

export const followCreatorFailure = createAction(
  followCreatorActionTypes.failure,
  (error) => ({ payload: error }),
);

export const followCreatorReset = createAction(followCreatorActionTypes.reset);

export const unfollowCreator = createAction(
  unfollowCreatorActionTypes.request,
  (payload) => ({ payload }),
);

export const unfollowCreatorSuccess = createAction(
  unfollowCreatorActionTypes.success,
  (payload) => ({ payload }),
);

export const unfollowCreatorFailure = createAction(
  unfollowCreatorActionTypes.failure,
  (error) => ({ payload: error }),
);
export const setCreatorSubscription = createAction(
  setCreatorSubscriptionActionTypes,
  (payload) => ({ payload }),
);

export const setCreatorSubscriptionPortion = createAction(
  setCreatorSubscriptionPortionActionTypes,
  (payload) => ({ payload }),
);

export const dontShowReport = createAction(
  hideReportActionTypes.request,
  (payload) => ({ payload }),
);

export const dontShowReportSuccess = createAction(
  hideReportActionTypes.success,
  (payload) => ({ payload }),
);

export const dontShowReportFailure = createAction(
  hideReportActionTypes.failure,
  (error) => ({ payload: error }),
);

export const setConversation = createAction(setConversationActionType);
